<template>
  <div>
    <div class="centered-column">
      <div class="container-header">
        <h3>{{ label.get('departments') }}</h3>
      </div>

      <div class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{label.get('preference')}}</label>
          </div>
        </div>
        <div class="toggle-dep no-border">
          <div class="check-wrapper switch-wrapper">
            <b-form-checkbox
                v-model="enableDepartments"
                @change="toggleDepartments"
            >
              {{ label.get('departments') }}
            </b-form-checkbox>
            <p class="disclaimer">
              {{ label.get('departments_description') }}
            </p>
          </div>
        </div>
      </div>

      <div class="white-card" v-if="enableDepartments">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{label.get('departments')}}</label>
          </div>
          <button
              class="add-new-btn"
              @click="createDepartment"
              v-if="enableDepartments && departments.length"
          >
            <i class="atto atto-add-more" />
            {{ label.get('add_new_department') }}
          </button>
        </div>
        <div
            v-if="enableDepartments"
            class="list-container"
            v-bind:class="{ 'departments-list' : departments.length }"
        >
          <div class="table-heading">
            <span class="heading-label name">{{ label.get('name') }}</span>
            <span class="heading-label members">{{ label.get('members') }}</span>
          </div>
          <ul class="settings-items-list all-departments">
            <li
                v-for="(department, idx) in departments"
                :key="idx"
            >
              <div class="no-department-members" v-if="department.id === null">
                <div class="department-name">
                  <i class="atto atto-info-grey-icon setting-icon" />
                  <h4 class="name">
                    {{ label.get('no_department') }}
                  </h4>
                </div>
                <div class="members">
                  <i class="atto atto-team setting-icon" />
                  <span class="member-no">
                    {{ getDepartmentMembersCount(department) }}
                  </span>
                </div>
              </div>
              <router-link v-if="department.id !== null" :to="{name: 'Department', params: {did: department.id}}">
                <div class="department-name">
                  <i class="atto atto-departments setting-icon" />
                  <h4 class="name">
                    {{ department.name }}
                  </h4>
                </div>
                <div class="members">
                  <i class="atto atto-team setting-icon" />
                <span class="member-no">
                  {{ department.total_members }}
                </span>
                </div>
                <div class="options">
                  <button
                      class="delete-member"
                      @click="deleteDepartment($event, department)"
                  >
                    <i class="atto atto-delete" />
                  </button>
                  <div class="arrow">
                    <i class="atto atto-r-arrow-b" />
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
        </div>

        <div class="no-items" v-if="!departments.length">
          <div class="item-wrap">
            <i class="no_departments" />
            <button
                class="atto-btn add-entry add-item"
                @click="createDepartment"
            >
              {{label.get('add_departments')}}
            </button>
            <p>
              {{label.get('no_departments_description')}}
            </p>
          </div>
        </div>
      </div>
    </div>
    <add-department-modal v-if="showCreateNewDepartment" />
    <delete-department-component
        v-if="deleteDepartmentModal"
        :department="departmentItem"
    />
  </div>
</template>

<script>
    import DepartmentService from '../services/DepartmentService';
    import AddDepartmentModal from '../components/AddNewDepartmentComponent';
    import DeleteDepartmentComponent from '../components/DeleteDepartmentComponent';

    export default {
        name: "AllDepartmentsComponent",
        components: {
          AddDepartmentModal,
          DeleteDepartmentComponent
        },
        data() {
            return {
                enableDepartments: this.$store.state.companySettings.enable_departments,
                addMembers: false,
                showCreateNewDepartment: false,
                //departments: this.getDepartments(),
                departmentMembers: '',
                departmentItem: null,
                deleteDepartmentModal: false,
            }
        },
        computed: {
          departments() {
            const list = this.$store.state.companyDepartments.map((item) => {
              const departmentMembersCount = this.getDepartmentMembersCount(item);
              return {
                id: item.id,
                name: item.name,
                total_members: departmentMembersCount
              };
            });
            const noDepartmentMembers = this.$store.state.members.filter(x => x.department_id === null);
            if(noDepartmentMembers.length > 0) {
              list.unshift({
                id: null,
                name: this.label.get('no_department'),
                total_members: `${noDepartmentMembers.length} ` + this.label.get('members')
              });
            }
            return list;
          }
        },
        mounted() {
          this.$root.$on('hideCreateDepartment', this.hideCreateDepartment);
          this.$root.$on('hideDeleteDepartment', this.hideDeleteDepartment);
          this.$root.$on('editDepartmentList', this.updateDepartments);
        },
        methods: {
            getDepartmentMembersCount(department) {
                const membersCount = this.$store.state.members.filter((item) => {
                   return item.department_id === department.id;
                }).length;

                if(membersCount === 0) {
                    return '0 ' + this.label.get('members');
                }
                if(membersCount === 1) {
                    return '1 ' + this.label.get('member') ;
                }
                return `${membersCount} ` + this.label.get('members');
            },
            createDepartment() {
              this.showCreateNewDepartment = true;
            },
            hideCreateDepartment(departments) {
                if (departments) {
                    departments.forEach((item) => {
                      this.$store.state.companyDepartments.unshift(item);
                    });
                }
                this.showCreateNewDepartment = false;
            },
            toggleDepartments() {
                const _this = this;
                this.$store.state.companySettings.enable_departments = !_this.enableDepartments;
                if (_this.debounce) {
                    clearTimeout(_this.debounce);
                }
                _this.debounce = setTimeout(() => {
                    DepartmentService.updateCompanySettings(_this.$store.state.companySettings).then((result) => {
                        console.log(result);
                        this.$awn.success(result.data.message);
                    }).catch((error) => {
                        console.log(error);
                    })
                }, 1000);
            },
            deleteDepartment(event, department) {
                event.preventDefault();
                event.stopPropagation();
                this.departmentItem = department;
                this.deleteDepartmentModal = true;
            },

            hideDeleteDepartment(department) {
                if (department) {
                    const index = this.departments.indexOf(department);
                    this.departments.splice(index, 1);
                    this.$store.state.companyDepartments = this.departments.filter(x => x.id !== null);
                    this.$store.state.members.forEach((member) => {
                        if(member.department_id === department.id) {
                            member.department_id = null;
                            member.department = null;
                        }
                    })
                }
                this.deleteDepartmentModal = false;
                this.departmentItem = null;
            },
            updateDepartments(department) {
                if (department) {
                    department.forEach((item) => {
                        this.departments.push(item);
                    });
                    this.$store.state.companyDepartments = this.departments;
                }
            }
        },
        beforeDestroy() {
          this.$root.$off('hideCreateDepartment');
          this.$root.$off('hideDeleteDepartment');
          this.$root.$off('editDepartmentList');
        }
    }
</script>

<style lang="scss" scoped>
    .content {
        &.settings-container {
            padding: 0;
        }
    }
    .toggle-dep p{
      margin-top: 4px;
      color: #666666;
      max-width: 410px;
    }
    .list-container{
      .table-heading{
        padding: 5px 16px 6px 20px !important;
        .heading-label{
          &.name{
            margin-left: 44px;
            width: 55%;
            display: flex;
            margin-right: -32px;
          }
        }
      }
    }
    .settings-items-list > li{
      padding: 0 !important;
    }
    .settings-items-list > li > a,
    .no-department-members{
      height: 50px;
      padding: 13px 8px 13px 20px;
      width: 100%;
      div.department-name {
    /*    min-width: 550px;*/
        margin-right: 10px;
        display: flex;
        align-items: center;
        width: 55%;

        i{
          margin-right: 20px;
          &.atto-info-grey-icon{
           &:before{
             content: '';
             width: 16px;
             height: 16px;
             background: url('~@assets/images/info-grey-icon.svg') no-repeat center center;
           }
          }
        }
        h4.name{
          font: $roboto-regular 0.9375rem/1.5rem $roboto-font;
        }
      }
      .members{
        display: flex;
        align-items: center;
        span.member-no{
          font: $roboto-regular 0.875rem/1rem $roboto-font;
          margin-left: 16px;
          text-transform: lowercase;
        }
      }
      &:hover{
        background-color: transparent;
      }
    }
    .white-card{
      .list-container{
        ul {
          li{
            &:hover{
              background-color: transparent;
            }
            a{
              height: 49px;
              &:hover{
                background-color: $atto-grey;
              }
            }
          }
        }
      }
    }




</style>